// Figma "Filter pill" / "Filter buttons": a 32px rounded chip. Selected pills keep 12px on the
// left and 6px on the right so the remove slot sits flush; the plain Filters button has 10px.
export const filterPillStyle = (theme, { isActive = false, hasSelection = false } = {}) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  height: 32,
  padding: hasSelection ? theme.spacing(0, 0.75, 0, 1.5) : theme.spacing(0, 1.25),
  borderRadius: "8px",
  border: `1px solid ${isActive ? theme.palette.tertiary[300] : theme.palette.system[400]}`,
  backgroundColor: isActive ? theme.palette.tertiary[300] : theme.palette.system[0],
  cursor: "pointer",
  "&:hover": {
    backgroundColor: isActive ? theme.palette.tertiary[300] : theme.palette.system[50]
  },
  "&:disabled": {
    cursor: "default",
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.grey[300]
  }
});

// Figma "components/button-medium": Inter 14/20 medium with 0.4px tracking, used for every pill
// and the Filters button label.
export const filterPillLabelSx = {
  ...{ fontSize: 14, lineHeight: "20px", fontWeight: 500 },
  letterSpacing: "0.4px",
  whiteSpace: "nowrap"
};
